export default {
  MODEL_FP: 1,
  CONTENT_FP: 2,
  AUTHORIZED_DOMAIN_FP: 3,
  ADS_BANNER_FP: 4,
  SOCIAL_BUTTON_FP: 5,
  DEFAULT_FP: 6,
  OTHERS: 7,
}
